import './Footer.css'
// import Socialmedia from '../Socailmedia/Socialmedia';

function Footer() {
  return (
    <>
    <footer>
      <p>
        <b>KKL Rehoming A New Jersey Nonprofit Corporation
          <br></br>
          DBA 12 Inch Tails - a 501 (c) (3)
          <br></br>
          EIN: 92-3227490    
          <br></br>
          © 2026 12 Inch Tails. All Rights Reserved.</b>
      </p>
    </footer>
    </>
  )
}

export default Footer;